export default "__VITE_ASSET__DqjFikMt__"